import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { companyInfo } from "../../data/mockData";
import { Phone, Menu, X, ChevronDown } from "lucide-react";

const NAV = [
  { path: "/", label: "Startseite" },
  { id: "l", label: "Leistungen", children: [
    { path: "/heizung", label: "Heizung & Wärme" },
    { path: "/bad-sanitaer", label: "Bad & Sanitär" },
    { path: "/regenerative-energien", label: "Regenerative Energien" },
    { path: "/smart-home", label: "Smart Home" },
    { path: "/klima", label: "Klima & Lüftung" },
  ]},
  { path: "/heizungsrechner", label: "Heizungsrechner" },
  { path: "/partner", label: "Partner" },
  { path: "/karriere", label: "Karriere" },
  { path: "/kontakt", label: "Kontakt" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [sub, setSub] = useState(false);
  const loc = useLocation();
  useEffect(() => { const f = () => setScrolled(window.scrollY > 20); window.addEventListener("scroll", f, { passive: true }); return () => window.removeEventListener("scroll", f); }, []);
  useEffect(() => { setOpen(false); setSub(false); }, [loc.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-white/80 backdrop-blur-xl shadow-[0_1px_20px_rgba(0,0,0,0.04)]" : "bg-white/60 backdrop-blur-lg"}`} role="banner">
      <div className="max-w-[1300px] mx-auto px-6 h-[74px] flex items-center justify-between">
        <Link to="/" className="shrink-0" aria-label="Hoffmann Haustechnik – Zur Startseite">
          <img src={companyInfo.logo} alt="Hoffmann Haustechnik Logo" className="h-11 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center" aria-label="Hauptnavigation">
          {NAV.map(link => link.children ? (
            <div key={link.id} className="relative group">
              <button className="flex items-center gap-1 px-4 py-2 text-[14px] font-medium text-[#555] hover:text-[#63b32e] transition-colors" aria-haspopup="true" aria-expanded="false">{link.label}<ChevronDown size={13} className="opacity-40 group-hover:rotate-180 transition-transform duration-300" aria-hidden="true" /></button>
              <div className="absolute top-full left-0 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 translate-y-1 group-hover:translate-y-0">
                <div className="bg-white/80 backdrop-blur-2xl rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.12)] border border-white/60 py-2 min-w-[220px]">
                  {link.children.map(c => <Link key={c.path} to={c.path} className={`block px-5 py-2.5 text-[14px] hover:bg-[#63b32e]/5 rounded-lg mx-1 transition-colors ${loc.pathname===c.path?"text-[#63b32e] font-medium":"text-[#555]"}`}>{c.label}</Link>)}
                </div>
              </div>
            </div>
          ) : (
            <Link key={link.path} to={link.path} className={`px-4 py-2 text-[14px] font-medium transition-colors ${loc.pathname===link.path?"text-[#63b32e]":"text-[#555] hover:text-[#63b32e]"}`}>{link.label}</Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a href={companyInfo.emergencyLink} className="bg-[#63b32e] text-white text-[13px] font-semibold px-5 py-2.5 rounded-full hover:bg-[#4a9622] transition-colors flex items-center gap-2 shadow-md shadow-[#63b32e]/20" aria-label="Notrufdienst anrufen">
            <Phone size={13} aria-hidden="true" />Notruf
          </a>
        </div>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label={open ? "Menü schließen" : "Menü öffnen"} aria-expanded={open}>{open ? <X size={22} /> : <Menu size={22} />}</button>
      </div>
      {open && (
        <div className="lg:hidden bg-white/90 backdrop-blur-2xl border-t border-black/[0.03] px-6 py-4 shadow-xl">
          {NAV.map(link => link.children ? (
            <div key={link.id}>
              <button onClick={() => setSub(!sub)} className="w-full flex items-center justify-between py-3 text-[15px] text-[#333] font-medium">{link.label}<ChevronDown size={14} className={sub?"rotate-180":""} /></button>
              {sub && link.children.map(c => <Link key={c.path} to={c.path} className="block pl-4 py-2 text-[14px] text-[#666]">{c.label}</Link>)}
            </div>
          ) : <Link key={link.path} to={link.path} className="block py-3 text-[15px] text-[#333] font-medium">{link.label}</Link>)}
          <a href={companyInfo.emergencyLink} className="flex items-center justify-center gap-2 mt-3 bg-[#63b32e] text-white font-semibold py-3 rounded-xl text-sm"><Phone size={14} />Notrufdienst</a>
        </div>
      )}
    </header>
  );
};
export default Header;
